import { useContext } from "react"
import { AppContext } from "../context/context"

const ToastPopup = () => {

    let { toastContent } = useContext(AppContext)

    return (
       
            <div className="toast-container top-0 start-50 translate-middle-x mt-3">
                <div className="toast " role="alert" aria-live="assertive" aria-atomic="true">
                   
                        <div className="toast-body poppins">
                        <div className="d-flex w-100 justify-content-center">
                            {toastContent}
                        </div>

                    </div>
                </div>
            </div>
   


    )
}

export default ToastPopup